import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getImageUrl } from '../utils/images';
import './Header.css';

function Header() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
    setDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle scroll to hide/show second nav row
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsScrolled(scrollY > 50); // Hide second row after scrolling 50px
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className="header">
      {/* First Row - Always Visible */}
      <nav className="navbar navbar-row-1">
        <div className="navbar-brand">
          <Link to="/">
            <img src={getImageUrl('/images/guyrules_header.png')} alt="GuyRules" className="header-logo" />
          </Link>
        </div>
        
        <ul className="navbar-nav navbar-nav-row-1">
          {(user?.profile === 'admin' || user?.profile === 'club') && (
            <li>
              <Link to="/club-guydom" title="Club Guydom">
                <i className="bi bi-suit-club-fill"></i>
                <span className="nav-text">Club Guydom</span>
              </Link>
            </li>
          )}
          
          <li>
            <Link to="/quiz" title="GuyRules Quiz">
              <i className="bi bi-question-circle"></i>
              <span className="nav-text">GuyRules Quiz</span>
            </Link>
          </li>
          
          {user ? (
            <li className="profile-dropdown" ref={dropdownRef}>
              <button 
                className="profile-button"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                title="Profile"
              >
                <i className="bi bi-person"></i>
                <span className="nav-text">Profile</span>
                <i className={`bi bi-chevron-${dropdownOpen ? 'up' : 'down'}`}></i>
              </button>
              {dropdownOpen && (
                <ul className="dropdown-menu">
                  <li>
                    <Link 
                      to="/profile" 
                      onClick={() => setDropdownOpen(false)}
                      className="dropdown-item"
                    >
                      <i className="bi bi-person"></i>
                      <span className="dropdown-text">View Profile</span>
                    </Link>
                  </li>
                  {user?.profile === 'admin' && (
                    <li>
                      <Link 
                        to="/admin" 
                        onClick={() => setDropdownOpen(false)}
                        className="dropdown-item"
                      >
                        <i className="bi bi-gear"></i>
                        <span className="dropdown-text">GR Admin</span>
                      </Link>
                    </li>
                  )}
                  <li>
                    <button 
                      onClick={handleLogout}
                      className="dropdown-item logout-item"
                    >
                      <i className="bi bi-box-arrow-right"></i>
                      <span className="dropdown-text">Logout</span>
                    </button>
                  </li>
                </ul>
              )}
            </li>
          ) : (
            <li>
              <Link to="/login" className="login-link" title="Login">
                <i className="bi bi-box-arrow-in-right"></i>
                <span className="nav-text">Login</span>
              </Link>
            </li>
          )}
        </ul>
      </nav>

      {/* Second Row - Hides on Scroll */}
      <nav className={`navbar navbar-row-2 ${isScrolled ? 'scrolled' : ''}`}>
        <ul className="navbar-nav navbar-nav-row-2">
          <li>
            <Link to="/rules" title="Browse">
              <i className="bi bi-list-ul"></i>
              <span className="nav-text">Browse</span>
            </Link>
          </li>
          <li>
            <Link to="/rules/random" title="Random Rule">
              <i className="bi bi-shuffle"></i>
              <span className="nav-text">Random Rule</span>
            </Link>
          </li>
          <li>
            <Link to="/rules/latest" title="Latest Rules">
              <i className="bi bi-clock-history"></i>
              <span className="nav-text">Latest Rules</span>
            </Link>
          </li>
          <li>
            <Link to="/categories" title="Categories">
              <i className="bi bi-grid-3x3-gap"></i>
              <span className="nav-text">Categories</span>
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;